"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryPublishDto = exports.HistoryPublishCreateDto = exports.HistoryPublishIdDto = exports.HistoryPublishTool = exports.HistoryPublishType = void 0;
const system_1 = require("../system");
var HistoryPublishType;
(function (HistoryPublishType) {
    HistoryPublishType["Running"] = "RUNNING";
    HistoryPublishType["Pending"] = "PENDING";
    HistoryPublishType["Done"] = "DONE";
    HistoryPublishType["Failed"] = "FAILED";
})(HistoryPublishType || (exports.HistoryPublishType = HistoryPublishType = {}));
var HistoryPublishTool;
(function (HistoryPublishTool) {
    HistoryPublishTool["Standards"] = "STANDARDS";
    HistoryPublishTool["Cms"] = "CMS";
    HistoryPublishTool["TagEngine"] = "TAG-ENGINE";
    HistoryPublishTool["Learnosity"] = "LEARNOSITY";
})(HistoryPublishTool || (exports.HistoryPublishTool = HistoryPublishTool = {}));
class HistoryPublishIdDto extends system_1.SystemExecutionContextDto {
}
exports.HistoryPublishIdDto = HistoryPublishIdDto;
class SourceType {
}
class HistoryPublishCreateDto extends system_1.SystemExecutionContextDto {
}
exports.HistoryPublishCreateDto = HistoryPublishCreateDto;
class HistoryPublishDto {
}
exports.HistoryPublishDto = HistoryPublishDto;
//# sourceMappingURL=history-publish.dto.js.map